import MainView from "views/MainView";
import MarkdownReact from "marked-react";
import { userTermsZH, userTermsEN } from "./data";
import React, { useEffect, useState } from "react";
import { useIntlContext, SupportedLocales } from "views/IntlContext";
import { queryStrToObject } from "request";
import { FormattedMessage } from "react-intl";

const UserTermsPage = () => {
  const { switchLanguage, locale } = useIntlContext();

  const [email, setEmail] = useState<string | undefined>(undefined);

  useEffect(() => {
    const queryData = queryStrToObject();
    if (queryData && queryData.lang) {
      switchLanguage?.(queryData.lang as SupportedLocales);
    }
  }, []);

  const renderer = {
    heading(children: React.ReactNode, level: any) {
      if (level === 2) {
        return <h1 className="font-bold text-2xl mb-2">{children}</h1>;
      } else if (level === 3) {
        return <h3 className="font-semibold text-lg mb-2 mt-3">{children}</h3>;
      }
      return <h2 className="font-bold text-xl mb-2">{children}</h2>;
    },
    link(href: string, text: React.ReactNode) {
      return (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className="text-primary underline font-bold"
        >
          {text}
        </a>
      );
    },
    listItem(children: React.ReactNode) {
      return <li className="py-2 mt-2">{children}</li>;
    },
    list(children: React.ReactNode) {
      return <ul className="pl-5 list-decimal">{children}</ul>;
    },
    paragraph(children: React.ReactNode) {
      return <p className="break-words py-1">{children}</p>;
    },
  };

  const handleClick = (event: React.MouseEvent) => {
    const clickedElement = event.target as HTMLElement;
    const emailLink = clickedElement.closest(
      "a[href^='mailto:']"
    ) as HTMLAnchorElement | null;

    if (emailLink) {
      const email = emailLink.href.replace("mailto:", "");
      event.preventDefault();

      setEmail(email);
      var aux = document.createElement("input");
      aux.setAttribute("value", email);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      // navigator.clipboard
      //   .writeText(email)
      //   .then(() => {
      //     console.log("Email copied to clipboard");
      //   })
      //   .catch((err) => {
      //     console.error("Copy error", err);
      //   });

      setTimeout(() => {
        setEmail(undefined);
      }, 1500);
    }
  };

  return (
    <MainView backgroundClassName="bg-white dark:bg-black1b1f1e">
      {email && (
        <div className="bg-black1b1f1e dark:bg-white bg-opacity-60 text-white dark:text-black333 fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 w-fit px-5 leading-8 rounded h-8">
          <FormattedMessage id="userTerms.email.copied" />
        </div>
      )}
      <div
        className="p-5 text-sm leading-[23px] whitespace-pre-line break-all"
        onClick={handleClick}
      >
        <MarkdownReact
          value={
            locale === SupportedLocales.Chinese ? userTermsZH : userTermsEN
          }
          renderer={renderer}
        ></MarkdownReact>
      </div>
    </MainView>
  );
};
export default UserTermsPage;
